import React, { useEffect, useRef, useState } from "react";
import { Collapse, Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FreezeUnfreezeHistory = ({
  Show,
  Hide,
  Title,
  freezeUnfreezeHistory,
  freezeLoader,
  tableRef,
  onMouseDown,
  unfreezeButtonLoader,
  unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry,
  remark,
  setRemark,
  fieldId,
  formFields,
  totalDataEntry,
  setSelectedFields,
  selectedFields,
}) => {
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const studyPermission = JSON.parse(
    localStorage.getItem("studyPermissionData")
  );
  const AppsRef = useRef(null);
  const [openAction, setOpenAction] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenAction(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  useEffect(() => {
    setOpenAction(false);
    setSelectedFields([]);
    setRemark("");
  }, [Show]);

  let checkFieldData = formFields?.find((item) => item.id === fieldId);
  let checkEntryStatus = totalDataEntry?.find(
    (item) => item.fieldId === fieldId
  );

  const handleCheckboxChange = (e, name, label) => {
    const isChecked = e.target.checked;
    setSelectedFields((prev) => {
      if (isChecked) {
        const alreadyExists = prev.some((item) => item.name === name);
        if (!alreadyExists) {
          return [...prev, { name, label }];
        }
        return prev;
      } else {
        return prev.filter((item) => item.name !== name);
      }
    });
  };

  let selectedDataFunction = () => {
    if (
      !(
        checkEntryStatus?.type.startsWith("custom") ||
        checkFieldData?.fieldUnit === "yes" ||
        checkFieldData?.customFieldRemark === "yes"
      )
    ) {
      setSelectedFields([
        {
          name: checkFieldData?.fieldName,
          label: checkFieldData?.fieldLabel,
        },
      ]);
    }
  };

  useEffect(() => {
    selectedDataFunction();
  }, []);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        placement="end"
        style={{ width: "700px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {freezeLoader ? (
            <PageLoader/>
          ) : (
            <>
              {(StudyMode == "DBP Mode" ||
                studyPermission?.liveUnfreezeField ||
                studyPermission?.qcUnfreezeField) &&
                !StudyMode?.startsWith("SDV") && (
                  <div className="p-3" ref={AppsRef}>
                    <div className="w-25">
                      <button
                        onClick={() => {
                          setOpenAction(!openAction);
                          selectedDataFunction();
                        }}
                        className={`updateProfile`}
                      >
                        <span>Unfreeze Now</span>
                      </button>
                    </div>
                    <Collapse in={openAction === true}>
                      <div>
                        {(checkEntryStatus?.type.startsWith("custom") ||
                          checkFieldData?.fieldUnit === "yes" ||
                          checkFieldData?.customFieldRemark === "yes") && (
                          <Form.Group className="mb-1">
                            <Form.Label className="fw-bold mb-1">
                              Fields{" "}
                              <abbr title="Required" className="text-danger">
                                *
                              </abbr>
                            </Form.Label>
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.fieldLabel} (${checkFieldData?.fieldName})`}
                              name="fieldLabel"
                              disabled={checkEntryStatus?.status !== "freezed"}
                              checked={selectedFields
                                ?.map((item) => item.name)
                                ?.includes(checkFieldData?.fieldName)}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  checkFieldData?.fieldName,
                                  checkFieldData?.fieldLabel
                                )
                              }
                            />
                            {checkFieldData?.fieldUnit === "yes" && (
                              <Form.Check
                                type="checkbox"
                                label={`${checkFieldData?.fieldUnitLabel} (${checkFieldData?.fieldUnitName})`}
                                name="fieldUnitLabel"
                                disabled={
                                  checkEntryStatus?.unitStatus !== "freezed"
                                }
                                checked={selectedFields
                                  ?.map((item) => item.name)
                                  ?.includes(checkFieldData?.fieldUnitName)}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    checkFieldData?.fieldUnitName,
                                    checkFieldData?.fieldUnitLabel
                                  )
                                }
                              />
                            )}
                            {checkFieldData?.customFieldRemark === "yes" && (
                              <Form.Check
                                type="checkbox"
                                label={`${checkFieldData?.customFieldRemarkLabel} (${checkFieldData?.customFieldRemarkName})`}
                                name="customFieldRemarkLabel"
                                disabled={
                                  checkEntryStatus?.valueRemarkStatus !==
                                  "freezed"
                                }
                                checked={selectedFields
                                  ?.map((item) => item.name)
                                  ?.includes(
                                    checkFieldData?.customFieldRemarkName
                                  )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    checkFieldData?.customFieldRemarkName,
                                    checkFieldData?.customFieldRemarkLabel
                                  )
                                }
                              />
                            )}
                            {checkEntryStatus?.type.startsWith("custom") && (
                              <>
                                {checkFieldData?.referenceRangeLowerLimit ===
                                  "yes" && (
                                  <Form.Check
                                    type="checkbox"
                                    label={`${checkFieldData?.referenceRangeLowerLimitLabel} (${checkFieldData?.referenceRangeLowerLimitName})`}
                                    name="referenceRangeLowerLimitLabel"
                                    disabled={
                                      checkEntryStatus?.referenceRangeLowerLimitStatus !==
                                      "freezed"
                                    }
                                    checked={selectedFields
                                      ?.map((item) => item.name)
                                      ?.includes(
                                        checkFieldData?.referenceRangeLowerLimitName
                                      )}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        checkFieldData?.referenceRangeLowerLimitName,
                                        checkFieldData?.referenceRangeLowerLimitLabel
                                      )
                                    }
                                  />
                                )}
                                {checkFieldData?.referenceRangeUpperLimit ===
                                  "yes" && (
                                  <Form.Check
                                    type="checkbox"
                                    label={`${checkFieldData?.referenceRangeUpperLimitLabel} (${checkFieldData?.referenceRangeUpperLimitName})`}
                                    name="referenceRangeUpperLimitLabel"
                                    disabled={
                                      checkEntryStatus?.referenceRangeUpperLimitStatus !==
                                      "freezed"
                                    }
                                    checked={selectedFields
                                      ?.map((item) => item.name)
                                      ?.includes(
                                        checkFieldData?.referenceRangeUpperLimitName
                                      )}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        checkFieldData?.referenceRangeUpperLimitName,
                                        checkFieldData?.referenceRangeUpperLimitLabel
                                      )
                                    }
                                  />
                                )}
                                {checkFieldData?.referenceRangeIndicator ===
                                  "yes" && (
                                  <Form.Check
                                    type="checkbox"
                                    label={`${checkFieldData?.referenceRangeIndicatorLabel} (${checkFieldData?.referenceRangeIndicatorName})`}
                                    name="referenceRangeIndicatorLabel"
                                    disabled={
                                      checkEntryStatus?.referenceRangeIndicatorStatus !==
                                      "freezed"
                                    }
                                    checked={selectedFields
                                      ?.map((item) => item.name)
                                      ?.includes(
                                        checkFieldData?.referenceRangeIndicatorName
                                      )}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        checkFieldData?.referenceRangeIndicatorName,
                                        checkFieldData?.referenceRangeIndicatorLabel
                                      )
                                    }
                                  />
                                )}
                                {checkFieldData?.clinicalSignificance ===
                                  "yes" && (
                                  <Form.Check
                                    type="checkbox"
                                    label={`${checkFieldData?.clinicalSignificanceLabel} (${checkFieldData?.clinicalSignificanceName})`}
                                    name="clinicalSignificanceLabel"
                                    disabled={
                                      checkEntryStatus?.clinicalSignificanceStatus !==
                                      "freezed"
                                    }
                                    checked={selectedFields
                                      ?.map((item) => item.name)
                                      ?.includes(
                                        checkFieldData?.clinicalSignificanceName
                                      )}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        checkFieldData?.clinicalSignificanceName,
                                        checkFieldData?.clinicalSignificanceLabel
                                      )
                                    }
                                  />
                                )}
                                {checkFieldData?.customRemark === "yes" && (
                                  <Form.Check
                                    type="checkbox"
                                    label={`${checkFieldData?.customRemarkLabel} (${checkFieldData?.customRemarkName})`}
                                    name="customRemarkLabel"
                                    disabled={
                                      checkEntryStatus?.remarkStatus !==
                                      "freezed"
                                    }
                                    checked={selectedFields
                                      ?.map((item) => item.name)
                                      ?.includes(
                                        checkFieldData?.customRemarkName
                                      )}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        checkFieldData?.customRemarkName,
                                        checkFieldData?.customRemarkLabel
                                      )
                                    }
                                  />
                                )}
                              </>
                            )}
                          </Form.Group>
                        )}
                        <Form.Group className="mb-1">
                          <Form.Label className="fw-bold mb-1">
                            Remark{" "}
                            <abbr title="Required" className="text-danger">
                              *
                            </abbr>
                          </Form.Label>
                          {checkEntryStatus?.type.startsWith("custom") ||
                          checkFieldData?.fieldUnit === "yes" ||
                          checkFieldData?.customFieldRemark === "yes" ? (
                            <Form.Control
                              onChange={(e) => setRemark(e.target.value)}
                              value={remark}
                              className="br3"
                              placeholder="Remark"
                              as="textarea"
                            />
                          ) : (
                            <Form.Control
                              onChange={(e) => setRemark(e.target.value)}
                              value={remark}
                              disabled={checkEntryStatus?.status !== "freezed"}
                              className="br3"
                              placeholder="Remark"
                              as="textarea"
                            />
                          )}
                        </Form.Group>
                        <div className="text-end">
                          <button
                            disabled={
                              !remark ||
                              selectedFields?.length === 0 ||
                              unfreezeButtonLoader
                            }
                            onClick={
                              unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry
                            }
                            className="updateProfile"
                            style={{ fontSize: 12 }}
                          >
                            {unfreezeButtonLoader ? (
                              <div className="hstack gap-2">
                                <Spinner size="sm"/> Unfreezing...
                              </div>
                            ) : (
                              "Unfreeze Now"
                            )}
                          </button>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                )}
              {freezeUnfreezeHistory?.length > 0 ? (
                <Table
                  ref={tableRef}
                  className="m-0 custom-table"
                  hover
                  striped
                >
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th
                        style={{ width: 120 }}
                        onMouseDown={(e) => onMouseDown(e, 1)}
                      >
                        Field Name
                      </th>
                      <th
                        style={{ width: 80 }}
                        onMouseDown={(e) => onMouseDown(e, 2)}
                      >
                        Status
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Remark</th>
                      <th
                        style={{ width: 120 }}
                        onMouseDown={(e) => onMouseDown(e, 4)}
                      >
                        Activity By
                      </th>
                      <th
                        style={{ width: 120 }}
                        onMouseDown={(e) => onMouseDown(e, 5)}
                      >
                        Date | Time
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {freezeUnfreezeHistory?.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}.</td>
                        <td title={item.fieldLabel}>{item.fieldName}</td>
                        <td className="text-capitalize">{item?.fieldStatus}</td>
                        <td>{item?.remark}</td>
                        <td>{item?.activityBy}</td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.createdAt}
                          </Moment>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="hstack justify-content-center h-100">
                  <NoDataFoundTable MSG={"History not found!"} />
                </div>
              )}
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FreezeUnfreezeHistory;
